import { useNomeBonificacao } from "@/hooks/useNomeBonificacao";
import { cn } from "@/lib/utils";

/**
 * Marca o tipo da NF. Por padrão só a de bonificação de metas aparece (a de
 * salário, a maioria, fica sem marca, inline ao lado do número); `sempre`
 * mostra também "Salário" — usado no cabeçalho do detalhe.
 */
export const TipoNFBadge = ({
  tipo,
  sempre = false,
  className,
}: {
  tipo?: string;
  sempre?: boolean;
  className?: string;
}) => {
  const nome = useNomeBonificacao();
  const bonificacao = tipo === "bonificacao";
  if (!bonificacao && !sempre) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full font-semibold",
        sempre ? "px-2.5 py-0.5 text-xs" : "ml-2 px-2 py-px text-[10px]",
        bonificacao ? "bg-primary/10 text-primary-text" : "bg-foreground/[0.07] text-foreground/80",
        className,
      )}
    >
      {bonificacao ? nome : "Salário"}
    </span>
  );
};
